/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */

import {
  OperationParameter,
  OperationURLParameter,
  OperationQueryParameter,
} from "@azure/core-client";
import { MonitoringDataPoint as MonitoringDataPointMapper } from "../models/mappers.js";

export const contentType: OperationParameter = {
  parameterPath: ["options", "contentType"],
  mapper: {
    defaultValue: "application/json",
    isConstant: true,
    serializedName: "Content-Type",
    type: {
      name: "String",
    },
  },
};

export const monitoringDataPoint: OperationParameter = {
  parameterPath: ["options", "monitoringDataPoint"],
  mapper: MonitoringDataPointMapper,
};

export const accept: OperationParameter = {
  parameterPath: "accept",
  mapper: {
    defaultValue: "application/json",
    isConstant: true,
    serializedName: "Accept",
    type: {
      name: "String",
    },
  },
};

export const endpoint: OperationURLParameter = {
  parameterPath: "endpoint",
  mapper: {
    serializedName: "endpoint",
    required: true,
    type: {
      name: "String",
    },
  },
};

export const apiVersion: OperationQueryParameter = {
  parameterPath: "apiVersion",
  mapper: {
    defaultValue: "2024-04-01-preview",
    isConstant: true,
    serializedName: "api-version",
    type: {
      name: "String",
    },
  },
};

export const ikey: OperationQueryParameter = {
  parameterPath: "ikey",
  mapper: {
    serializedName: "ikey",
    required: true,
    type: {
      name: "String",
    },
  },
};

export const transmissionTime: OperationParameter = {
  parameterPath: ["options", "transmissionTime"],
  mapper: {
    serializedName: "x-ms-qps-transmission-time",
    type: {
      name: "Number",
    },
  },
};

export const machineName: OperationParameter = {
  parameterPath: ["options", "machineName"],
  mapper: {
    serializedName: "x-ms-qps-machine-name",
    type: {
      name: "String",
    },
  },
};

export const instanceName: OperationParameter = {
  parameterPath: ["options", "instanceName"],
  mapper: {
    serializedName: "x-ms-qps-instance-name",
    type: {
      name: "String",
    },
  },
};

export const streamId: OperationParameter = {
  parameterPath: ["options", "streamId"],
  mapper: {
    serializedName: "x-ms-qps-stream-id",
    type: {
      name: "String",
    },
  },
};

export const roleName: OperationParameter = {
  parameterPath: ["options", "roleName"],
  mapper: {
    serializedName: "x-ms-qps-role-name",
    type: {
      name: "String",
    },
  },
};

export const invariantVersion: OperationParameter = {
  parameterPath: ["options", "invariantVersion"],
  mapper: {
    serializedName: "x-ms-qps-invariant-version",
    type: {
      name: "String",
    },
  },
};

export const configurationEtag: OperationParameter = {
  parameterPath: ["options", "configurationEtag"],
  mapper: {
    serializedName: "x-ms-qps-configuration-etag",
    type: {
      name: "String",
    },
  },
};

export const monitoringDataPoints: OperationParameter = {
  parameterPath: ["options", "monitoringDataPoints"],
  mapper: {
    serializedName: "monitoringDataPoints",
    type: {
      name: "Sequence",
      element: {
        type: {
          name: "Composite",
          className: "MonitoringDataPoint",
        },
      },
    },
  },
};
